/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI Calculator — Body Mass Index (Metric & Imperial) | Toolverse`)
};

const es_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC — Índice de Masa Corporal (Métrico e Imperial) | Toolverse`)
};

const de_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI-Rechner — Body-Mass-Index (Metrisch & Imperial) | Toolverse`)
};

const nl_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI-rekenmachine — Body Mass Index (Metrisch en Imperiaal) | Toolverse`)
};

const fr_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur IMC — Indice de masse corporelle (Métrique et impérial) | Toolverse`)
};

const it_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMI — Indice di Massa Corporea (Metrica e Imperiale) | Toolverse`)
};

const pt_br2_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de BMI — Índice de Massa Corporal (Métrico e Imperial) | Toolverse`)
};

const pt_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC — Índice de Massa Corporal (Métrico e Imperial) | Toolverse`)
};

const ja_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI計算機—体格指数（メートル法とインペリアル法）| Toolverse`)
};

const zh_bmi_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI 计算器——身体质量指数（公制与英制）| Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_meta_title", locale)
	if (locale === "en") return en_bmi_hub_meta_title(inputs)
	if (locale === "es") return es_bmi_hub_meta_title(inputs)
	if (locale === "de") return de_bmi_hub_meta_title(inputs)
	if (locale === "nl") return nl_bmi_hub_meta_title(inputs)
	if (locale === "fr") return fr_bmi_hub_meta_title(inputs)
	if (locale === "it") return it_bmi_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_meta_title(inputs)
	if (locale === "pt") return pt_bmi_hub_meta_title(inputs)
	if (locale === "ja") return ja_bmi_hub_meta_title(inputs)
	return zh_bmi_hub_meta_title(inputs)
};